class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.threshold = 140; // Scrolled distance to trigger header visibility toggle
    this.header = this; // Reference to the sticky header element itself
    this.searchInput = this.querySelector('input[type="search"]');
    this.handleScroll = this.handleScroll.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.mobileMenuTriggers = document.querySelectorAll('.js-nav-mobile');

    this.announcementBar = document.querySelector('.shopify-section--announcement-bar');
    this.sectionHeader = document.querySelector('.shopify-section-header');
  }

  connectedCallback() {
    this.calculateHeight()
    window.addEventListener('scroll', this.handleScroll);

    window.addEventListener('resize', this.handleScroll);

    window.addEventListener('resize', () => {
      this.handleScroll();

      setTimeout(() => {
        this.calculateHeight();
      }, 1000);
    });

    this.handleScroll(); // Initial check on load

    // Attach focus and blur listeners to the search input
    if (this.searchInput) {
      this.searchInput.addEventListener('focus', this.handleFocus);
      this.searchInput.addEventListener('blur', this.handleBlur);
    }

    this.mobileMenuTriggers.forEach(mobileMenuTrigger => {
      mobileMenuTrigger.addEventListener('click', (event) => {
        event.preventDefault();

        const menuTarget = document.getElementById(mobileMenuTrigger.dataset.target);

        if (menuTarget) {
          menuTarget.click();
        };

        mobileMenuTrigger.classList.toggle('open');
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);

    if (this.searchInput) {
      this.searchInput.removeEventListener('focus', this.handleFocus);
      this.searchInput.removeEventListener('blur', this.handleBlur);
    }
  }

  isDropdownVisible() {
    // Check if any `.nav-dropdown` is visible
    const dropdowns = this.querySelectorAll('.nav-dropdown');
    return Array.from(dropdowns).some(dropdown => {
      const style = window.getComputedStyle(dropdown);
      return style.visibility === 'visible';
    });
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    this.calculateHeight()

    // Check if scrolled more than 140px
    if (scrollTop > this.threshold && !this.isDropdownVisible()) {
      // Determine scroll direction
      if (scrollTop > this.lastScrollTop) {
        // Scrolling down
        this.header.classList.add('is-hidden');
      } else {
        // Scrolling up
        this.header.classList.remove('is-hidden');
      }
    } else {
      // Reset to visible state if within the threshold or if dropdown is visible
      this.header.classList.remove('is-hidden');
    }

    // Update last scroll position
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Ensure it doesn't go negative
  }

  calculateHeight() {
    const headerBottomHeight = this.querySelector('.header__bottom').offsetHeight;
    const announcementHeight = this.announcementBar.offsetHeight;
    const initHeight = this.sectionHeader.offsetHeight - headerBottomHeight;
    const windowScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const totalHeight = windowScrollTop < announcementHeight
      ? initHeight + announcementHeight
      : initHeight;

    document.documentElement.style.setProperty('--header-offset', `${totalHeight}px`);
  }

  handleFocus() {
    this.header.classList.add('focused');
  }

  handleBlur() {
    this.header.classList.remove('focused');
  }
}

// Define the custom element
customElements.define('sticky-header', StickyHeader);
